import generic_backend_request_post from 'functions/server/generic_backend_request_post';

/**
 * Re-own the runs a user submitted anonymously, now that they've signed in.
 *
 * Anonymous runs are stored under a throwaway client UUID; on sign-in we ask the
 * backend to reassign every run currently owned by `anonymousUserId` to the
 * verified Clerk token subject (the bearer token is attached automatically).
 *
 * @param {string} anonymousUserId - the throwaway UUID the runs were submitted under.
 * @returns {Promise<{success: boolean, data: {claimed: number}}>}
 */
export default async function claim_runs(anonymousUserId) {
  return generic_backend_request_post({ anonymousUserId }, '/claim_runs');
}
